// 页面配置
export const PAGE_CONFIG = {
  personal: {
    path: '/personalAdd',
    type: 'personal',
  },
  enterprise: {
    path: '/enterpriseAdd',
    type: 'enterprise',
  },
  enterpriseSub: {
    path: '/enterpriseSubAdd',
    type: 'enterpriseSub',
  },
  enterpriseSubBatch: {
    path: '/enterpriseSubBatchAdd',
    type: 'enterpriseSubBatch',
  },
}

// 个人订单续约步骤
export const PERSONAL_ADD_STEPS = [
  {
    title: '原订单信息',
    icon: '',
    description: '',
  }, {
    title: '租赁信息',
    icon: '',
    description: '',
  }, {
    title: '订单确认',
    icon: '',
    description: '',
  },
]

// 企业订单续约步骤
export const ENTERPRISE_ADD_STEPS = [
  {
    title: '原订单信息',
    icon: '',
    description: '',
  }, {
    title: '订单续约信息',
    icon: '',
    description: '',
  },
]

// 企业子订单续约步骤
export const ENTERPRISE_SUB_ADD_STEPS = [
  {
    title: '原订单信息',
    icon: '',
    description: '',
  }, {
    title: '租赁信息',
    icon: '',
    description: '',
  },
]

// 企业子订单批量续约步骤
export const ENTERPRISE_SUB_BATCH_ADD_STEPS = [
  {
    title: '批量选择续约订单',
    icon: '',
    description: '',
  }, {
    title: '租赁信息',
    icon: '',
    description: '',
  },
]
